import { useReduxState } from 'hooks';
import { RichTextValue } from 'components/common';
import { Box } from 'components/common/box';
import { PageContent, PageHeader } from 'components/page';

import type { ReduxRootState } from 'types';
import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  customPage: ReduxRootState['serverConfig']['customPages'][0];
}

const CustomPage = ({ customPage }: Props) => {
  const { language, theme } = useReduxState();

  const headerTitle =
    customPage.headerTitleTranslations?.[language] || customPage.headerTitle;

  const headerDescription =
    customPage.headerDescriptionTranslations?.[language] ||
    customPage.headerDescription;

  const infoTitle =
    customPage.infoTitleTranslations?.[language] || customPage.infoTitle;

  const infoText =
    customPage.infoTextTranslations?.[language] || customPage.infoText;

  return (
    <div className="custom-page">
      <PageHeader
        icon={customPage.headerIcon as IconProp}
        title={headerTitle}
        titleDescription={headerDescription}
      />

      <PageContent>
        {infoTitle || infoText ? (
          <div className="info">
            <Box>
              {infoTitle ? <div className="info-title">{infoTitle}</div> : null}

              {infoText ? (
                <div className="info-text">
                  <RichTextValue html={infoText} />
                </div>
              ) : null}
            </Box>
          </div>
        ) : null}
      </PageContent>

      <style jsx>{`
        .info {
          margin: 20px 0;
        }
        .info-title {
          color: ${theme.textColor};
          font-size: 1.6rem;
          font-weight: 700;
        }
        .info-text {
          color: ${theme.textColorLight};
          font-size: 1.5rem;
          font-weight: 400;
          margin-top: 10px;
        }
      `}</style>
    </div>
  );
};

export default CustomPage;
